import React from 'react';
import { Star, ExternalLink } from 'lucide-react';
import { GBP_REVIEW_URL } from '../data/constants';
import { trackReviewClick } from '../lib/analytics';

// P13 — Google reviews. Empty-safe: with no Google Places API data configured,
// show ONLY the two Google links. Never render placeholder/invented review text,
// names or star counts.
export const ReviewsSection = ({ reviews = null, location = 'home' }) => {
  const hasLiveData = Array.isArray(reviews) && reviews.length > 0;
  return (
    <section data-testid="reviews-section" className="py-16 bg-gray-50">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="font-heading font-bold text-3xl text-[#1E3A5F] mb-3">
          What Calgary customers say
        </h2>
        {hasLiveData ? (
          <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3 mt-8 text-left">
            {reviews.slice(0, 5).map((r, i) => (
              <div key={i} className="bg-white rounded-xl p-5 border border-gray-200">
                <div className="flex gap-0.5 mb-2">
                  {Array.from({ length: Math.round(r.rating || 0) }).map((_, s) => (
                    <Star key={s} className="w-4 h-4 text-amber-400 fill-amber-400" />
                  ))}
                </div>
                <p className="text-gray-700 text-sm">{r.text}</p>
                <p className="text-gray-500 text-xs mt-3">
                  {r.author} · {r.relativeTime} · via Google
                </p>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-gray-600 max-w-xl mx-auto mb-8">
            Read what our customers think, or share your own experience — right on Google.
          </p>
        )}
        <div className="flex flex-col sm:flex-row gap-3 justify-center mt-8">
          <a
            href={GBP_REVIEW_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="reviews-read-google"
            onClick={() => trackReviewClick(`${location}:read`)}
            className="inline-flex items-center justify-center gap-2 bg-[#1E3A5F] text-white font-semibold px-6 py-3 rounded-lg hover:bg-[#152A45] transition-colors"
          >
            <ExternalLink className="w-4 h-4" /> Read our reviews on Google
          </a>
          <a
            href={GBP_REVIEW_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="reviews-leave-google"
            onClick={() => trackReviewClick(`${location}:leave`)}
            className="inline-flex items-center justify-center gap-2 border border-[#1E3A5F] text-[#1E3A5F] font-semibold px-6 py-3 rounded-lg hover:bg-[#1E3A5F]/5 transition-colors"
          >
            <Star className="w-4 h-4" /> Leave a review
          </a>
        </div>
      </div>
    </section>
  );
};

export default ReviewsSection;
